import React from 'react';
import {Button, Drawer} from 'shared/ui';

export type ReceiptCheckingBannerProps = {
	text: string;
};

function ReceiptCheckingMark(): React.ReactElement {
	return (
		<span className="flex h-14 w-14 flex-none items-center justify-center bg-[#FFF174]" aria-hidden="true">
			<svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fill="#121212"
					fillRule="evenodd"
					d="M2 1h16v15v2h-2v-2h-2v2h-2v-2h-2v2h-2v-2h-2v2h-2v-2h-2V1Zm4 3.8h8v1.45H6V4.8Zm0 2.9h8v1.45H6V7.7Z"
				/>
			</svg>
		</span>
	);
}

export function ReceiptCheckingBanner({text}: ReceiptCheckingBannerProps): React.ReactElement {
	const [open, setOpen] = React.useState(false);
	const close = React.useCallback(() => setOpen(false), []);

	return (
		<>
			<button type="button" onClick={() => setOpen(true)} className="mb-7 block w-full text-left focus:outline-none">
				<span className="flex cursor-pointer items-center gap-4 bg-white p-2 focus-visible:ring-2">
					<ReceiptCheckingMark />
					<span className="text-normal leading-snug text-black">{text}</span>
				</span>
			</button>

			<Drawer
				open={open}
				onClose={close}
				showCloseButton
				titleIcon={<ReceiptCheckingMark />}
				title={text}
				footerContent={
					<Button className="!w-full !px-6 !py-4 !text-base" onClick={close}>
						Окей
					</Button>
				}
			>
				<p className="text-base leading-relaxed text-black">
					Обычно это занимает до 10 минут.
					<br />
					Когда проверим — переведём деньги на ваш счёт
				</p>
			</Drawer>
		</>
	);
}
